var _defs, _path, _path2, _path3, _path4, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.9,51.84a2.69,2.69,0,0,1-1.29-.33,2.72,2.72,0,0,1-1.43-2.39V18.55A10.4,10.4,0,0,1,17.57,8.16H42.43A10.4,10.4,0,0,1,52.82,18.55V36.36A10.4,10.4,0,0,1,42.43,46.75H19.64a3.83,3.83,0,0,0-2.1.63l-6.15,4A2.76,2.76,0,0,1,9.9,51.84Zm7.67-41.68a8.4,8.4,0,0,0-8.39,8.39V49.12a.7.7,0,0,0,.38.63.72.72,0,0,0,.74,0l6.15-4a5.82,5.82,0,0,1,3.19-1H42.43a8.4,8.4,0,0,0,8.39-8.39V18.55a8.4,8.4,0,0,0-8.39-8.39Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.31,27.44a3.07,3.07,0,1,1-3.07-3.06A3.09,3.09,0,0,1,22.31,27.44Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.06,27.44A3.07,3.07,0,1,1,30,24.38,3.08,3.08,0,0,1,33.06,27.44Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.82,27.44a3.07,3.07,0,1,1-3.06-3.06A3.08,3.08,0,0,1,43.82,27.44Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 60,
    height: 60
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.ca7904d7c4f01cbba8528f4bc4c57f6e.svg";
export { ForwardRef as ReactComponent };